export const tiposAnexo = [
    { id: 1, descricao: 'Boletim de Medição' },
    { id: 2, descricao: 'Nota Fiscal' },
    { id: 3, descricao: 'Certidões ou Documentos Comprobatórios' },
    { id: 4, descricao: 'Outros Documentos' },
    { id: 5, descricao: 'Planilha de Medição (Não assinada)' },
    { id: 6, descricao: 'Planilha de Medição (Assinada pelo Fornecedor)' },
    { id: 7, descricao: 'Planilha de Medição (Assinada pelo Fiscal Terceiro)' },
    { id: 8, descricao: 'Planilha de Medição (Assinada por Suape)' },
    { id: 9, descricao: 'Memória de Cálculo (Assinada pelo Fornecedor)' },
    { id: 10, descricao: 'Cronograma Físico Financeiro (Assinado pelo Fornecedor)' },
    { id: 11, descricao: 'Curva S (Assinada pelo Fornecedor)' },
    { id: 12, descricao: 'Planta Falada (Assinada pelo Fornecedor)' },
    { id: 13, descricao: 'Declaração de Vinculo (Assinada pelo Fornecedor)' },
    { id: 14, descricao: 'Memória de Cálculo (Assinada por Suape)' },
    { id: 15, descricao: 'Cronograma Físico Financeiro (Assinado por Suape)' },
    { id: 16, descricao: 'Curva S (Assinada por Suape)' },
    { id: 17, descricao: 'Planta Falada (Assinada por Suape)' },
    { id: 18, descricao: 'Declaração de Vínculo (Assinada por Suape)' },
    { id: 19, descricao: 'Documento Reprovado' },
]

export const tiposAnexoEnum = {
    BoletimMedicao: 1,
    NotaFiscal: 2,
    CertidoesDocumentosComprobatorios: 3,
    OutrosDocumentos: 4,
    MedicaoNaoAssinada: 5,
    MedicaoAssinadaPeloFornecedor: 6,
    MedicaoAssinadaPeloFiscalTerceiro: 7,
    MedicaoAssinadaPeloFiscalObras: 8,
    MemoriaCalculoAssinadaPeloFornecedor: 9,
    CronogramaFisicoFinanceiroAssinadoPeloFornecedor: 10,
    CurvaSAssinadaPeloFornecedor: 11,
    PlantaFaladaAssinadaPeloFornecedor: 12,
    DeclaracaoVinculoAssinadaPeloFornecedor: 13,
    MemoriaCalculoAssinadaPeloFiscalObras: 14,
    CronogramaFisicoFinanceiroAssinadoPeloFiscalObras: 15,
    CurvaSAssinadaPeloFiscalObras: 16,
    PlantaFaladaAssinadaPeloFiscalObras: 17,
    DeclaracaoVinculoAssinadaPeloFiscalObras: 18,
    Reprovado: 19,
}
